const microsHost = window.ini.API_BASE_URL;
const aclHostName = window.ini.ACL_BASE_URL + "/acl";
const wsHost = microsHost;

export const endpoints = {
  // auth service
  user: {
    login: aclHostName + "/authorization/v1/login",
    logout: aclHostName + "/authorization/v1/logout",
    check: aclHostName + "/authorization/v1/check",
    refresh: aclHostName + "/authorization/v1/refresh",
    profile: aclHostName + "/users/v1/user",
  },

  session: {
    getLocations: aclHostName + "/configuration/v1/locations",
    startSession: microsHost + "/cashier/v1/session/start",
    check: microsHost + "/cashier/v1/session/check",
  },

  websocket: {
    host: wsHost,
    path: "/ws", //"/api/notifications-ws/v1/connect",
  },

  deposit: {
    identify: microsHost + "/cashier/v1/player/identify",
    deposit: microsHost + "/cashier/v1/player/deposit",
  },

  withdrawal: {
    withdrawal: microsHost + "/cashier/v1/player/withdraw-check",
    cashout: microsHost + "/cashier/v1/player/withdraw-execute",
  },

  operator: {
    listTransactions: microsHost + "/cashier/v1/operator/list-transactions",
    exportTransactions: microsHost + "/cashier/v1/operator/export-transactions",
    listCashRegisterTransactions: microsHost + "/cashier/v1/operator/list-cash-register-transactions",
    getTransaction: microsHost + "/cashier/v1/operator/get-transaction",
  },
};
